<template>
  <div class="work-order-constitute">
    <div class="constitute-container">
      <div class="chart-section">
        <div ref="chartRef" class="chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { postAction } from '@/api/manage'

export default {
  name: 'WorkOrderConstitute',
  data() {
    return {
      chart: null,
      option: {},
      url: {
        queryTicketsTypeNum: "/jeecg-engineering/ticket/index/largeScreen/queryTicketsTypeNum"
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.disposeChart()
  },
  methods: {
    async init() {
      await this.getData()
      this.$nextTick(() => {
        this.initChart()
      })
    },
    async getData() {
      try {
        const res = await postAction(this.url.queryTicketsTypeNum, { queryType: '' })
        if (res.success && res.result) {
          const data = res.result
          let num0 = 0, num1 = 0, num2 = 0
          
          data.forEach(d => {
            if (d.typeName == 0) {
              num0 = d.num || 0
            } else if (d.typeName == 1) {
              num1 = d.num || 0
            } else {
              num2 = (d.num || 0) + num2
            }
          })
          
          this.setOption(num0, num1, num2)
        } else {
          this.loadMockData()
        }
      } catch (error) {
        console.error('获取工单构成数据失败:', error)
        this.loadMockData()
      }
    },
    loadMockData() {
      this.setOption(378, 267, 456)
    },
    setOption(a, b, c) {
      const total = a + b + c
      const data = [
        { value: a, name: this.$t('换表') },
        { value: b, name: this.$t('工程报装') },
        { value: c, name: this.$t('故障报修') }
      ]
      
      const color = [
        { start: '#0C2D82', end: '#3A7BD5' },
        { start: '#B620E0', end: '#4634FA' },
        { start: '#50E3C2', end: '#32C5FF' }
      ]
      
      const color1 = [
        { start: '#fff', end: '#3A7BD5' },
        { start: '#fff', end: '#4634FA' },
        { start: '#fff', end: '#FA6400' }
      ]
      
      const seriesData = []
      for (let i = 0; i < data.length; i++) {
        seriesData.push({
          name: data[i].name,
          value: data[i].value,
          itemStyle: {
            normal: {
              borderWidth: 5,
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: color[i].start },
                  { offset: 1, color: color[i].end }
                ]
              ),
              borderColor: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: color[i].start },
                  { offset: 1, color: color[i].end }
                ]
              )
            }
          }
        })
      }
      
      this.option = {
        color: ['#0C2D82', '#B620E0', '#50E3C2'],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF'
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        title: {
          text: `{total|${total}}{unit|${this.$t('件')}}`,
          textStyle: {
            color: '#52C4DF',
            rich: {
              total: {
                color: '#52C4DF',
                fontWeight: 500,
                fontSize: 30,
                fontFamily: 'ds-digital-bold'
              },
              unit: {
                color: '#2A6BAC',
                fontSize: 12
              }
            }
          },
          left: 'center',
          top: 'center',
          itemGap: 0,
          subtext: this.$t('总数量'),
          subtextStyle: {
            color: '#fff',
            verticalAlign: 'middle',
            lineHeight: 12
          }
        },
        series: [{
          name: '',
          type: 'pie',
          roseType: 'area',
          radius: ['50%', '80%'],
          center: ['50%', '50%'],
          animationDelay: 100,
          animationDuration: 2000,
          label: {
            show: true,
            position: 'outer',
            width: 0,
            height: 0,
            lineHeight: 0,
            padding: [2, -2, 2, -2],
            borderRadius: 2,
            distanceToLabelLine: 0,
            formatter: (params) => {
              const percent = ((params.value / total) * 100).toFixed(0)
              const index = params.dataIndex
              return [
                `{topnumber${index}|${params.value}}{top${index}|${this.$t('件')}}{topnumber${index}|${percent}}{top${index}|%}\n{bottom${index}|${params.name}}`,
                `{hr${index}|}`
              ].join('\n')
            },
            align: 'center',
            color: '#fff',
            rich: this.setRichText(color1)
          },
          labelLine: {
            normal: {
              smooth: 0.2,
              length: 15,
              length2: 45
            }
          },
          data: seriesData
        }]
      }
    },
    setRichText(colorList) {
      const richList = {}
      for (let i = 0; i < colorList.length; i++) {
        richList[`top${i}`] = {
          color: colorList[i].start,
          verticalAlign: 'bottom',
          padding: [5, 0, 0, 0],
          align: 'center'
        }
        richList[`topnumber${i}`] = {
          color: colorList[i].start,
          fontFamily: 'ds-digital-bold',
          verticalAlign: 'bottom',
          padding: [5, 0, 0, 0],
          fontSize: 20,
          align: 'center'
        }
        richList[`bottom${i}`] = {
          color: colorList[i].start,
          verticalAlign: 'top',
          padding: [0, 0, 5, 0],
          align: 'center'
        }
        richList[`hr${i}`] = {
          backgroundColor: colorList[i].start,
          borderRadius: 3,
          width: 3,
          height: 3,
          align: 'center',
          padding: [3, 3, 0, -12]
        }
      }
      return richList
    },
    initChart() {
      if (!this.$refs.chartRef) return
      
      this.chart = echarts.init(this.$refs.chartRef)
      this.chart.setOption(this.option)
      
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
        window.removeEventListener('resize', this.handleResize)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.work-order-constitute {
  height: 100%;
  padding: 15px;
}

.constitute-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.chart-section {
  flex: 1;
  background: rgba(0, 48, 111, 0.2);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 8px;
  padding: 15px;
  display: flex;
  flex-direction: column;
}

.chart {
  flex: 1;
  width: 100%;
  min-height: 200px;
}

@media (max-width: 768px) {
  .work-order-constitute {
    padding: 10px;
  }
  
  .constitute-container {
    gap: 10px;
  }
  
  .chart-section {
    padding: 10px;
  }
}
</style>